<script>
  const API_URL = process.env.API_SERVER_URL
  const IMG_URL = process.env.IMAGE_CDN_URL

  export default {
    urls: {
      car: API_URL + '/car/',
      car_manage_photo: API_URL + '/car/{car_id}/photo/',

      car_update_brand: API_URL + '/car/{car_id}/brand/',
      car_update_description: API_URL + '/car/{car_id}/description/',
      car_update_model: API_URL + '/car/{car_id}/model/',
      car_update_price: API_URL + '/car/{car_id}/price/',
      car_update_status: API_URL + '/car/{car_id}/status/',
      car_update_year: API_URL + '/car/{car_id}/year/',

      hot_cars: API_URL + '/car/status/hot',
      image_url: IMG_URL + '/{car_id}/{file_name}'
    }
  }
</script>



// WEBPACK FOOTER //
// Config.vue?1f884ac4